import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import PageContainer from '@/components/ui/containers/PageContainer'

import WaitingRoomsTable from './containers/WaitingRoomsTable'

export function WaitingRoomsPage() {
  const { t } = useTranslation()

  return (
    <PageContainer>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} spacing={2}>
        <Typography variant="h2" sx={{ mt: '30px', mb: '30px' }}>
          {t('page.waitingRooms.title')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button component={Link} to="/super-admin/waiting-rooms/create" variant="contained">
            {t('page.waitingRooms.createWaitingRoomButton.label')}
          </Button>
        </Box>
      </Stack>
      <WaitingRoomsTable />
    </PageContainer>
  )
}

export default WaitingRoomsPage
